import React from "react";

import Mobileheader from "../component/Mobiledashboard/Mobileheader";

import Mobilenav from "../component/Mobiledashboard/Mobilenav";
import Mobilesettingsbody from "../component/Mobiledashboard/Mobilesettingsbody";

const Mobilesettings = () => {
  return (
    <div className="h-screen px-6 pt-[50px] bg-[radial-gradient(89.62%_213.03%_at_38.75%_80.3%,_#07031C_0%,_#241D4A_30.52%,_#07031C_64.32%)]">
      <Mobileheader />
      <Mobilesettingsbody/>
      <Mobilenav />
    </div>
  );
};

export default Mobilesettings;
